import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, Search } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <Helmet>
        <title>Page Not Found - KoKo Sites</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you're looking for doesn't exist. Visit KoKo Sites for professional web design services across India." />
      </Helmet>
      <div className="text-center max-w-lg">
        <p className="text-[10rem] font-black leading-none text-red-600/10">404</p>
        <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-tight text-white -mt-8 mb-4">
          Page Not <span className="text-red-600">Found</span>
        </h1>
        <p className="text-sm text-zinc-400 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let's get you back to building something great.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="404-home-link" className="inline-flex items-center justify-center gap-2 bg-red-600 text-white font-bold uppercase tracking-widest py-3 px-8 text-xs hover:bg-white hover:text-black transition-all duration-300">
            <ArrowLeft size={14} /> Back to Home
          </Link>
          <Link to="/#contact" data-testid="404-contact-link" className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-bold uppercase tracking-widest py-3 px-8 text-xs hover:border-red-600 hover:text-red-500 transition-all duration-300">
            <Search size={14} /> Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
